import { render, staticRenderFns } from "./addResume.vue?vue&type=template&id=b403ed06&scoped=true&"
import script from "./addResume.vue?vue&type=script&lang=js&"
export * from "./addResume.vue?vue&type=script&lang=js&"
import style0 from "./addResume.vue?vue&type=style&index=0&id=b403ed06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b403ed06",
  null
  
)

export default component.exports